import { CustomModal } from 'common/components/custom-modal/CustomModal'
import { feedbackData } from 'features/code-review/data/feedbackData'
import { FeedbackModel, FeedbackTypeEnum, ReviewStatusType } from 'features/code-review/service'

import { FeedbackItem } from './feedback-item/FeedbackItem'

type Props = {
  defaultFeedbacks: FeedbackModel[]
  onClose: () => void
  open: boolean
  reviewId: number
  reviewStatus: ReviewStatusType
  studentComment: string | null
}

export const ReviewModal = ({
  defaultFeedbacks,
  onClose,
  open,
  reviewId,
  reviewStatus,
  studentComment,
}: Props) => {
  const disableAcceptButton = !defaultFeedbacks.find(
    feedback => feedback.type === FeedbackTypeEnum.GENERAL && feedback.feedback
  )
  const disableRejectButton = !defaultFeedbacks.find(
    feedback => feedback.type === FeedbackTypeEnum.REJECTED && feedback.feedback
  )

  return (
    <CustomModal modalTitle={'Отзыв'} onClose={onClose} open={open}>
      {feedbackData.map(item => {
        const defaultFeedback = defaultFeedbacks.find(feedback => feedback.type === item.type)

        return (
          <FeedbackItem
            defaultFeedback={defaultFeedback}
            disableAcceptButton={disableAcceptButton}
            disableRejectButton={disableRejectButton}
            feedback={item}
            key={item.id}
            onModalClose={onClose}
            reviewId={reviewId}
            reviewStatus={reviewStatus}
            studentComment={item.type === FeedbackTypeEnum.GENERAL ? studentComment : null}
          />
        )
      })}
    </CustomModal>
  )
}
